export const isRedirectedToSimplexUrl = (locationPath: string, url: string | false) => {
  // eslint-disable-next-line no-console
  console.debug(`URL external ${url + locationPath} arrived to utils/simplex`);
  return false;
};
